// find first value to meet this condition or the last one
export const handleRecommended = (plans = [], overage = 0) => plans.find((p) => p.capacity >= overage) || plans[plans.length - 1];

// check if 'excessPriceCents' available
export const getExcessPriceCents = (excessPrice) => {
  if (typeof excessPrice === 'string' && excessPrice.includes('$')) {
    return Number(excessPrice.replace('$', '')) * 100;
  } else {
    return excessPrice;
  }
};

export const UNLIMITED_CMR = 'Unlimited';